import { render, staticRenderFns } from "./dialog-edit-detail-bzf-unit-price-jz.vue?vue&type=template&id=4382f716&scoped=true&"
import script from "./dialog-edit-detail-bzf-unit-price-jz.vue?vue&type=script&lang=js&"
export * from "./dialog-edit-detail-bzf-unit-price-jz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4382f716",
  null
  
)

export default component.exports